function setSessionForMenu(e) {
    window.sessionStorage.setItem("currentSiteMenu", `${e}`);
}
function applyHover(e, t, l, n, i) {
    var a = t.querySelector(l);
    a && (a.style.color = i), n ? t && (t.style.background = e) : t && (t.classList.contains("active") ? (t.style.background = e) : (t.style.background = "transparent"));
}
let debounceTimer;
function handleSlideNav(e, t) {
    t.preventDefault();
    try {
        let l = t.currentTarget,
            n = parseInt(l.getAttribute("data-slide")),
            i = l.getAttribute("data-disabled");
        if ("true" == i) return;
        clearTimeout(debounceTimer),
            (debounceTimer = setTimeout(() => {
                let t = l.offsetParent,
                    i = (t = t.querySelector(".shoppable-blog__slider")).childNodes.length,
                    a = t.offsetWidth,
                    s;
                switch (e) {
                    case "prev":
                        (s = l.nextElementSibling),
                            n - 1 == 1 && l.setAttribute("data-disabled", "true"),
                            s.setAttribute("data-disabled", "false"),
                            s.setAttribute("data-slide", n - 1),
                            l.setAttribute("data-slide", n - 1),
                            t.scrollBy({ top: 0, left: -a, behavior: "smooth" });
                        break;
                    case "next":
                        (s = l.previousElementSibling),
                            n + 1 == i && l.setAttribute("data-disabled", "true"),
                            s.setAttribute("data-disabled", "false"),
                            s.setAttribute("data-slide", n + 1),
                            l.setAttribute("data-slide", n + 1),
                            t.scrollBy({ top: 0, left: +a, behavior: "smooth" });
                }
            }, 400));
    } catch (a) {}
}
!(function () {
    !(function e() {
        var t = document.querySelector(".delivery-expendite");
        if (t) {
            var l = t.dataset.expendite,
                n = 10,
                i = 15;
            "BUSAN" == l ? ((n = 4), (i = 8)) : "USA" == l && ((n = 5), (i = 8));
            var a = new Date(),
                s = new Date();
            a.setDate(a.getDate() + n), s.setDate(s.getDate() + i);
            var r = a.toLocaleString("en-US", { month: "long" }),
                o = a.getFullYear(),
                d = a.getDate(),
                c = s.toLocaleString("en-US", { month: "long" }),
                u = s.getFullYear(),
                y = s.getDate(),
                v = "";
            o != u && (v = " " + o), console.log(d, y, r, c), (t.innerHTML += "<span class='dl-label'>Expected delivery by</span><span class='dl-date'> " + r + " " + d + v + " - " + c + " " + y + ", " + u + "</span>");
        }
    })(),
        document.querySelectorAll(".sale-countdown").forEach(function (e) {
            var t = 1e3 * e.dataset.saleEndDate;
            function l() {
                var l = t - new Date().getTime();
                (e.innerHTML =
                    "<ul><li><div class='sale-countdown-number'>" +
                    Math.floor(l / 864e5).toString().padStart(2, '0') +
                    "</div><div class='sale-countdown-time'>days</div></li><li><div class='sale-countdown-number'>" +
                    Math.floor((l % 864e5) / 36e5).toString().padStart(2, '0') +
                    "</div><div class='sale-countdown-time'>hrs</div></li><li><div class='sale-countdown-number'>" +
                    Math.floor((l % 36e5) / 6e4).toString().padStart(2, '0') +
                    "</div><div class='sale-countdown-time'>mins</div></li><li><div class='sale-countdown-number'>" +
                    Math.floor((l % 6e4) / 1e3).toString().padStart(2, '0') +
                    "</div><div class='sale-countdown-time'>secs</div></li></ul>"),
                    l < 0 && (clearInterval(e.timerInterval), (e.innerHTML = ""));
            }
            t && "" !== t && (l(), (e.timerInterval = setInterval(l, 1e3)));
        });
    var e = document.getElementById("dlt-account");
    e &&
        e.addEventListener("click", function (e) {
            var t = e.currentTarget,
                l = e.currentTarget.offsetParent,
                n = l.querySelector(".delete-close"),
                i = l.querySelector(".btn--outline"),
                a = l.querySelector(".delete-content"),
                s = l.querySelector("h4"),
                [r, o] = t.children;
            (n.style.display = "none"),
                (i.style.display = "none"),
                (r.style.display = "block"),
                (o.style.display = "none"),
                (s.innerHTML = "Requesting for deleting the account!"),
                fetch("https://dodoskin-dashboard.vercel.app/api/v1/shopify/delete", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ customerId: Number(t.dataset.id), value: !0 }) })
                    .then((e) => e.json())
                    .then((e) => {
                        (n.style.display = "block"),
                            (i.style.display = "block"),
                            (r.style.display = "none"),
                            (o.style.display = "block"),
                            (s.innerHTML = "Are you absolutely sure?"),
                            (a.innerHTML = "This action cannot be undone. This will permanently delete your account and remove your data from the store."),
                            (location.href = "/account");
                    })
                    .catch((e) => {
                        (n.style.display = "block"),
                            (i.style.display = "block"),
                            (r.style.display = "none"),
                            (o.style.display = "block"),
                            (s.innerHTML = "Oops! something went wrong."),
                            (a.innerHTML = "Something went wrong while requesting the deletion of your account.");
                    });
        }),
        document.querySelectorAll(".nav-link"),
        window.location.pathname;
    var t = document.getElementById("shop"),
        l = document.getElementById("sheet-modal"),
        n = document.getElementById("sheet-overlay");
    t.addEventListener("click", function () {
        var e = document.getElementById("mobile-menu-left-drawer");
        e &&
            requestAnimationFrame(function () {
                e.click();
            });
    }),
        n.addEventListener("click", function () {
            l.classList.remove("open"), n.classList.remove("visible");
        });
    var i = document.querySelector(".jdgm-rev-widg__title");
    if (i) {
        var a = document.createElement("p");
        (a.innerText = "Join the Discussion"), a.classList.add("review-desc"), i.after(a);
    }
    let s = document.querySelectorAll(".custom-links-section");
    s &&
        s.forEach(function (e) {
            let t = e.querySelector(".toggle-links"),
                l = e.querySelector(".links-container"),
                n = t.querySelector(".chevron-down-link"),
                i = t.querySelector(".chevron-up-link");
            t.addEventListener("click", function () {
                l.classList.contains("expanded") ? (l.classList.remove("expanded"), (i.style.display = "none"), (n.style.display = "block")) : (l.classList.add("expanded"), (i.style.display = "block"), (n.style.display = "none"));
            });
        });
    let accesibilityLink = document.querySelector("#accesibility-link");
    accesibilityLink && accesibilityLink.addEventListener("click", function(){
      var accessiblyAppDialogButton  = document.querySelector("#accessiblyAppDialogButton");
      if(typeof accessiblyAppDialogButton != "undefined"){
        accessiblyAppDialogButton.click();
      }
    });
})();

// Function to hide elements when shadowRoot is available
function hideChatElements() {
  const shadowRoot = document.querySelector("#ShopifyChat")?.shadowRoot || null;
  
  if (shadowRoot) {
    // Create a new <style> element to append custom styles
    const style = document.createElement('style');
    style.innerHTML = `
      .return-to-chat-wrapper { display: none !important; }
      .composer-bar-form, .composer-bar-chatView, .message-prompt { display: none !important; }
      .message-container{padding-bottom:10px;}
      /* You can add more custom styles here */
    `;
    
    // Append the style element to the shadowRoot
    shadowRoot.appendChild(style);
  }
}

// Observer to check if #ShopifyChat is added to the DOM
const observer = new MutationObserver((mutations, obs) => {
  const shopifyChat = document.querySelector("#ShopifyChat");
  if (shopifyChat) {
    obs.disconnect(); // Stop observing once element is found
    hideChatElements()
   
  }
});

// Start observing the body for changes
observer.observe(document.body, { childList: true, subtree: true });

